import DOMPurify from 'dompurify'

export const sanitizeHtml = (html) => DOMPurify.sanitize(html ?? '')

const applySafeHtml = (el, binding) => {
    el.innerHTML = sanitizeHtml(binding.value)
}

const addSafeHtmlDirective = (app) => {
    app.directive('safe-html', {
        mounted: applySafeHtml,
        updated: applySafeHtml
    })
}

export default addSafeHtmlDirective
